module.exports = __webpack_public_path__ + "img/explainB.43364f3b.png";